import { LinkValue } from '@/lib/sanity/portable-text/marks/link.mark';
import type { ButtonVariant } from '@/lib/sanity/dto';

export const LINK_VARIANT_MAP: Record<NonNullable<LinkValue['variant']>, string> = {
    'pt-text-link': 'underline underline-offset-2 hover:text-primary',
    'pt-btn-link': 'btn btn-link-primary btn-lg',
    'pt-btn-primary': 'btn btn-primary btn-lg mt-2 lg:mt-0',
    'pt-btn-secondary': 'btn btn-outline btn-lg mt-2 lg:mt-0',
};

/** A navItem's weight as a button. The dark surfaces re-point the tokens behind
 *  these classes (`surfaces.css`), so one class serves every ground. */
export const BUTTON_VARIANT_MAP: Record<ButtonVariant, string> = {
    primary: 'btn-primary',
    secondary: 'btn-outline',
    link: 'btn-link-primary',
};
